import type { HTTPError } from 'ky'

export const isHttpError = (error: unknown): error is HTTPError =>
    error instanceof Error &&
    error.name === 'HTTPError' &&
    'response' in error &&
    error.response instanceof Response &&
    'request' in error &&
    error.request instanceof Request
